// One-click add for the cart drawer upsell list. Mirrors the theme's ProductForm flow
// (bundled sections + variant:add / cart:change events) so the drawer re-renders itself.
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-cart-upsell-add]');
  if (!button || button.getAttribute('aria-busy') === 'true') return;

  button.setAttribute('aria-busy', 'true');
  try {
    const sections = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));

    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.cartUpsellAdd), quantity: 1 }],
        sections: sections.join(','),
        sections_url: `${Shopify.routes.root}variants/${button.dataset.cartUpsellAdd}`
      })
    });
    const responseJson = await response.json();
    if (!response.ok) {
      button.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: responseJson.description } }));
      return;
    }

    const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cart.sections = responseJson.sections;
    button.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: responseJson.items || [responseJson], cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
  } finally {
    button.removeAttribute('aria-busy');
  }
});
